import React, {useRef, useState} from 'react';
import Modal from '../../../../Modal/Modal';
import LoadingIndicator from '../../../../LoadingIndicator/LoadingIndicator';
import styled from 'styled-components';
import CreateEditSampleBody from './CreateEditSampleBody';

const CreateEditSampleModal = ({
	showModal,
	modalTitle,
	isLoading,
	onCloseModal,
	saveAndClose,
	saveAndCreateAnother,
	modalDescription,
	sampleLabels,
	inputFields,
	setInputFields,
	showSaveAndCreateNewButton = false,
	saveAndCloseTitle,
	saveAndCreateAnotherTitle
}) => {
	const [loaderHeight, setLoaderHeight] = useState(0);
	const modalRef = useRef(null);

	const getHeightOfSection = () => {
		if (modalRef.current) {
			setLoaderHeight(modalRef.current.clientHeight);
		}
	};

	const renderBody = () => {
		return (
			<section ref={modalRef}>
				<CreateEditSampleBody
					modalDescription={modalDescription}
					sampleLabels={sampleLabels}
					inputFields={inputFields}
					setInputFields={setInputFields}
				/>
			</section>
		);
	};

	const loaderProps = {
		height: loaderHeight
	};

	return (
		<Modal
			show={showModal}
			modalsize={'small'}
			showButtons={true}
			title={modalTitle}
			closeBtnTitle={sampleLabels.cancel}
			saveAndCreateNewBtnTitle={saveAndCreateAnotherTitle}
			confirmBtnTitle={saveAndCloseTitle}
			onHide={() => onCloseModal()}
			closeTitle={sampleLabels.cancel}
			isOkButtonDisabled={isLoading}
			isSaveAndCreateNewButtonDisabled={isLoading}
			isCancelButtonDisabled={isLoading}
			onOkClick={() => {
				getHeightOfSection();
				saveAndClose();
			}}
			onSaveAndCreateNew={() => {
				getHeightOfSection();
				saveAndCreateAnother() || null;
			}}
			showSaveAndCreateNewButton={showSaveAndCreateNewButton}
			okTitle={saveAndCloseTitle}
			disableClose={isLoading}
		>
			<StyledBodyContent>
				{isLoading ? (
					<section style={loaderProps} className="loader-section">
						<LoadingIndicator show view="inlineView" />
					</section>
				) : (
					renderBody()
				)}
			</StyledBodyContent>
		</Modal>
	);
};

export default CreateEditSampleModal;

const StyledBodyContent = styled.section`
	display: inline-grid;
	width: 100%;
	.modal-description {
		font-size: var(--px-16);
		font-weight: 300;
		line-height: var(--px-24);
		color: var(--neutrals-900);
		padding-bottom: var(--px-24);
		border-bottom: var(--px-1) solid var(--neutrals-100);
	}
	.error-message-styling {
		height: var(--px-24);
	}
	.sample-description-section {
		padding-top: var(--px-24);
	}
	.loader-section {
		display: flex;
		justify-content: center;
		align-items: center;
	}
`;
